import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/q77bjwMRMbBGmvZT5JH8LX/IMAGEN_1.webp', 'https://cdn.magicpatterns.com/uploads/wLELzCnb8fF4eLyBTcN6fy/IMAGEN_2.webp', 'https://cdn.magicpatterns.com/uploads/6wFovkehyeoJuq4uLXVsvj/IMAGEN_3.webp', 'https://cdn.magicpatterns.com/uploads/uajVbCyhQ2CNLhqdmhDWqY/IMAGEN_4.webp', 'https://cdn.magicpatterns.com/uploads/6N3fKXUMvJALREvDP6PdoS/imagen_5.webp', 'https://cdn.magicpatterns.com/uploads/vLJehWRT43VmuV1FtNpC4v/imagen_6.webp', 'https://cdn.magicpatterns.com/uploads/rMELAUcZtXgAR7ZBagSR3W/imagen_7.webp'];
export function ProductCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-20 bg-[#fdfaf6] overflow-hidden pt-[40px] pb-[40px]" data-id="element-136">
      <div className="max-w-6xl mx-auto px-4" data-id="element-137">
        <h2 className="text-3xl md:text-4xl font-bold text-[#5d4037] text-center mb-12" data-id="element-138">
          Explorá el Material por Dentro
        </h2>

        <div className="relative w-full group min-h-[400px] flex items-center justify-center bg-black/5" data-id="element-139">
          <AnimatePresence mode="wait" data-id="element-140">
            <motion.img key={currentIndex} src={images[currentIndex]} initial={{
            opacity: 0,
            x: 50
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -50
          }} transition={{
            duration: 0.8,
            ease: 'easeInOut'
          }} className="max-w-full max-h-[700px] object-contain" data-id="element-141" />
          </AnimatePresence>

          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-142">
            {images.map((_, i) => <div key={i} className={`h-2 rounded-full transition-all ${i === currentIndex ? 'w-8 bg-[#d4af37]' : 'w-2 bg-white/50'}`} data-id="element-143" />)}
          </div>
        </div>
      </div>
    </section>;
}